import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CashCreditRequest, CashCreditEmi, PersonalLoanPricingCap, EmiOption } from './cash-credit';
import { ApplicationService } from '../../application/application.service';
import { Loader, LoaderService } from '../../common/loader/loader.service';
import { EmailMobileService } from '../../customer/email-mobile/email-mobile.service';
import { TokenService } from '../../token/token.service';
import { environment } from '../../../environments/environment';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';

declare var $: any;

@Component({
  selector: 'zest-cash-credit',
  templateUrl: './cash-credit.component.html',
  styleUrls: ['./cash-credit.component.scss']
})

export class CashCreditComponent implements OnInit {

  public sliderMinRange: number;
  public sliderMaxRange: number;
  public sliderSteps: number;
  public cashCreditSliderConfig: any = {};
  public amount: number;
  public recommendedOptions: CashCreditEmi[];
  public otherOptions: CashCreditEmi[];
  public cashCredit = new CashCreditRequest();
  public email: string;
  public phone: string;
  public processingFee: any;
  public disbursalAmount: any;
  public s3BucketUrl = environment.s3BucketUrl;
  public showProcessingFee: boolean;
  public fetchingProcessingFee: boolean;
  public amountReceiver: Subject<string> = new Subject<string>();
  public isLoaderVisible: boolean;
  public recommendedOptionsOne: EmiOption[];

  @Input() pricing: PersonalLoanPricingCap;
  @Input() merchantName: string;
  @Input() merchantId: string;

  constructor(private applicationService: ApplicationService, private tokenService: TokenService, private emailMobileService: EmailMobileService, private loaderService: LoaderService, private router: Router) {
    this.amountReceiver.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(() => {
      this.getProcessingFee();
    });
  }

  ngOnInit() {
    this.setProcessingFeeFlag();
    this.initializeSlider();
    this.fetchEmiData();
    this.createCashCreditApplicationData();
  }

  setProcessingFeeFlag() {
    const merchant = this.merchantName.replace(/\s/g, '').toLowerCase();
    if (environment.customThemeMerchants.includes(merchant)) {
      this.showProcessingFee = true;
    }
  }
  initializeSlider() {
    this.sliderMinRange = Math.floor(this.pricing.MinLoanAmount / 1000);
    this.sliderMaxRange = Math.floor(this.pricing.MaxLoanAmount / 1000);
    this.sliderSteps = 1;
    this.cashCreditSliderConfig = {
      behaviour: 'tap-drag',
      keyboard: true,
      connect: true,
      tooltips: true,
      start: this.sliderMaxRange,
      step: this.sliderSteps,
      pageSteps: this.sliderSteps,
      range: {
        min: this.sliderMinRange,
        max: this.sliderMaxRange
      },
      pips: {
        mode: 'steps',
        density: this.sliderMinRange,
        values: this.sliderMinRange,
        stepped: true
      }
    };
    this.cashCredit.amount = this.sliderMaxRange;
    this.selectAmount(this.cashCredit.amount);
  }
  getProcessingFee() {
    this.fetchingProcessingFee = true;
    this.applicationService.getMerchantPersonalLoanPricing(this.merchantId, this.cashCredit.amount * 1000).subscribe(response => {
      this.fetchingProcessingFee = false;
      this.processingFee = response.EmiOptions[0].ProcessingFee;
      if (this.processingFee) {
        this.disbursalAmount = Number(this.cashCredit.amount * 1000) - Number(this.processingFee);
      } else {
        this.disbursalAmount = this.cashCredit.amount * 1000;
      }
    }, error => {
      this.fetchingProcessingFee = false;
      this.processingFee = 0;
    });
  }
  createCashCreditApplicationData() {
    this.email = this.tokenService.getCustomerDetails().email;
    this.emailMobileService.getMobile().subscribe(response => {
      this.phone = response.PhoneNumber;
    });
  }
  getCashCreditApplication() {
    this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
    this.applicationService.createPersonalLoanApplication((this.cashCredit.amount * 1000), this.cashCredit.tenure, this.phone, this.email, this.merchantId, this.pricing.Type).subscribe(response => {
      const applicationId = response.ApplicaitonId;
      this.applicationService.getOrderDetails(applicationId).subscribe(applicationResponse => {
        this.tokenService.removeAllExceptToken();
        this.applicationService.saveApplication(applicationResponse);
        this.router.navigate(['/loggedinredirect']);
      });
    });
  }
  selectAmount(amount) {
    this.isLoaderVisible = true;
    const divisions = (this.sliderMaxRange - this.sliderMinRange) / this.sliderSteps;
    const diff = ((100 / divisions) * ((amount - this.sliderMinRange) / this.sliderSteps)).toFixed(2);
    setTimeout(() => {
      $('.noUi-connects').css('background-image', 'linear-gradient(to right, #ddd, #ddd ' + diff + '%, #EEEEEE ' + diff + '%, #EEEEEE 100%)');
    }, 10);
  }
  updateTenure(tenure: CashCreditEmi) {
    this.cashCredit.tenure = tenure.NumberOfMonths;
    this.cashCredit.emi = tenure.TotalMonthlyAmount;
  }
  toggleAmountBreakupModal(status: string) {
    setTimeout(fn => { $('#amountBreakup').modal(status); }, 0);
  }

  fetchPricingData() {
    this.fetchEmiData();
  }
  fetchEmiData() {
    this.applicationService.getPersonalLoanEmiOptionsPricing(this.cashCredit.amount * 1000, this.pricing.Type).subscribe(pricing => {
      this.recommendedOptions = pricing.EmiOptions;
      const defaultTenure = this.recommendedOptions.filter(plan => {
        return plan.NumberOfMonths <= 12;
      }).pop();
      if (defaultTenure) {
        this.cashCredit.tenure = defaultTenure.NumberOfMonths;
        this.cashCredit.emi = defaultTenure.TotalMonthlyAmount;
      } else {
        this.cashCredit.tenure = this.recommendedOptions[this.recommendedOptions.length - 1].NumberOfMonths;
        this.cashCredit.emi = this.recommendedOptions[this.recommendedOptions.length - 1].TotalMonthlyAmount;
      }
      this.calculateProcessingFee();
      this.isLoaderVisible = false;
    });
  }
  calculateProcessingFee() {
    this.processingFee = this.recommendedOptions.find(item => item.NumberOfMonths === this.cashCredit.tenure).ProcessingFee;
    if (this.processingFee) {
      this.disbursalAmount = Number(this.cashCredit.amount * 1000) - Number(this.processingFee);
    } else {
      this.disbursalAmount = this.cashCredit.amount * 1000;
    }
  }
}
